// import {useShowContext} from 'ra-core';
import Spinner from '@/components/basic/Spinner';
import {defaultQueryOptions} from '@/pages/_utils';
import {useShow} from '@refinedev/core';
// import ShowPage from 'pages/_shared/show-page';
import createDOMPurify from 'dompurify';
import {useMemo, useRef} from 'react';

const DOMPurify = createDOMPurify(window);

const ProjectContractShow = () => {
  const {query} = useShow({
    queryOptions: {
      ...defaultQueryOptions,
    },
    meta: {
      with: [],
    },
  });

  const {data, isFetching, isError, refetch} = query;
  const record = data?.data;

  const contentHtmlRef = useRef<any>();

  const cleanHtml = useMemo(() => {
    if (!record || !record.content) return '';
    const html = DOMPurify.sanitize(record.content, {USE_PROFILES: {html: true}});
    return html;
  }, [record]);

  if (isFetching || !record) {
    return <Spinner />;
  }

  return (
    <div>
      <h1>{record.name}</h1>
      <p className="mt-4 mb-4">{record.description}</p>
      <div
        id="contentHtml"
        ref={contentHtmlRef}
        dangerouslySetInnerHTML={{__html: cleanHtml}}></div>
    </div>
  );
};

export default ProjectContractShow;
